<!-- AI分析 -->
<template>
  <div class="page-container common-blue-contain bg-contain">
    <div class="search-container search">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <!-- 机构列表 -->
        <el-form-item :label="$t('mechanism')">
          <el-select
              ref="paramOuSelect"
              v-model="searchForm.ouName"
              style="width:auto"
              :placeholder="$t('mechanism')"
              :popper-append-to-body="false"
              @change="changeOu"
              clearable
              @visible-change="visibleChange"
          >
            <el-option :value="searchForm.ouName" style="height:auto;padding:0px">
                <el-tree
                  ref="paramOuTree"
                  node-key="id"
                  default-expand-all
                  highlight-current
                  :expand-on-click-node="false"
                  :data="ouList"
                  :props="defaultProps"
                  @node-click="selectParamOu"
                >
                </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('userNameH')">
          <el-input v-model="searchForm.userName" clearable :placeholder="$t('userNameH')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('serialNumberP2')">
          <el-input v-model="searchForm.deviceId" clearable :placeholder="$t('serialNumberP2')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('AIAnalysisType')">
          <el-select v-model="searchForm.type" clearable :placeholder="$t('AIAnalysisType')" :popper-append-to-body="false">
            <el-option v-for="(item,index) in identificationType" :label="item.label" :value="item.value" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('Recordtime')" class="datetime">
          <el-date-picker
            v-model="searchForm.startTime"
            :placeholder="$t('startDate')"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm:ss"
            popper-class="date-picker-blue-hw"
            :clearable="true"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('TO')" class="datetime">
          <el-date-picker
            v-model="searchForm.endTime"
            :placeholder="$t('endDate')"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd 23:59:59"
            popper-class="date-picker-blue-hw"
            :clearable="true"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPageData">{{ $t('query') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <transition name="el-zoom-in-center">
      <div class="content" v-if="data.length > 0" v-loading="loading" element-loading-text="拼命加载中">
        <div class="one-line">
          <div class="tag">
            <div class="title">
              <span class="type-tag"></span>
              <span class="type-line"></span>
            </div>
            <div class="medias">
              <ul>
                <li v-for="(d, index2) in data" :key="index2">
                  <!-- 图片 -->
                  <div class="picture">
                    <div class="box">
                      <el-image
                        :src="d.fileUrl"
                        :title="d.location"
                        class="pic"
                        :lazy="true"
                        :preview-src-list="[d.fileUrl]"
                      >
                      </el-image>
                    </div>
                    <div class="pic_contrl">
                      <div class="flex_just_between lh20">
                        <h5 class="video-time-pic">
                          <span>{{ d.deviceName }}-{{ d.deviceSn }}</span>
                          <span>{{ d.logTimestamp }}</span>
                        </h5>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[15, 30, 60, 120]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.totalData"
        >
      </el-pagination>
      </div>
      <div
        class="content"
        v-else
        v-loading="loading"
        element-loading-text="拼命加载中"
        style="text-align: center;padding-top: 20px;"
      >
        {{ loading ? '' : '暂无数据' }}
      </div>
      
    </transition>
    
  </div>
</template>

<script>
import { getAiAnalysisData,getAiAnalysisHistoryType } from '@/api/new-set'
import { getOus } from '@/api/UserList'
import { beforeWeekDate, nowDate } from '@/util/date'
export default {
  name: 'aiAnalysis',
  data() {
    return {
      searchForm: {
        ouId: '',
        ouName: '',
        userName:'',
        deviceId: '', // 设备ID
        type:'', // AI分析类型
        startTime: beforeWeekDate()+' 00:00:00', // 开始日期
        endTime: nowDate() + ' 23:59:59', // 结束日期
      },
      data: [],
      // 机构列表
      ouList: [],
      loading: false,
      identificationType:[],
      pagination:{
        currentPage: 1,
        pageSize: 15,
        totalData: 0
      },
      defaultProps: {
        children: 'children',
        label: 'name',
      },
    }
  },
  methods: {
    //根据后台返回的AI分析类型值，匹配前端显示的label
          
    //   })
    // },
    mapAIAnalysisList(obj){
      let arr = []
      for(let key in obj ){
        arr.push({value:key,label:obj[key]})
      }
      return arr
    },
    // 获取AI分析类型列表
    getAIAnalysisList() {
      getAiAnalysisHistoryType().then(res => {
        if (res.state === 0) {
          let list = this.mapAIAnalysisList(res.data)
          this.identificationType = list
        }
      })
    },
    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.searchForm.ouName = data.name
      this.searchForm.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 清空过滤条件机构，过滤用户
    changeOu(data) {
      if (!data) {
        this.searchForm.ouId = null
        this.searchForm.ouName = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.ouList = res.data
        }
      })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.getPageData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getPageData()
    },
    // 查询数据
    getPageData() {
      this.loading = true
      let params = {
        ouId: this.searchForm.ouId,
        deviceName: this.searchForm.userName,
        deviceSn: this.searchForm.deviceId,
        analyseType: this.searchForm.type,
        logTimestampBegin: this.searchForm.startTime,
        logTimestampEnd: this.searchForm.endTime,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      }
      getAiAnalysisData(params).then(res => {
        if(res.state===0){
          this.data = res.data.list||[]
          this.pagination.totalData = res.data.total
          this.loading = false
        }
      })
    },
  },
  mounted() {
    this.getAIAnalysisList()
    this.getPageData()
  },
  created() {
    this.getOusTree()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.page-container {
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: auto;
  background-color: #EEF5FE;

  .search-container {
    margin: 20px 30px 0px 30px;
    // width: 93%;
  }
  .content {
    position: absolute;
    top: 60px;
    left: 30px;
    right: 30px;
    bottom: 10px;
    font-size: 20px;
    color: #333;
    .tags {
      height: 32.8%;
    }
    .tag {
      height: 100%;
    }
    .title {
      position: relative;
      .type-tag {
        position:relative;
        display:inline-block;
        // width: 100%
        height: 36px;
        line-height: 36px;
        color: #0e65dd;
        font-weight: bold;
        font-size: 20px;
      }
      .type-line {
        position:absolute;
        background:#ccc;
        content:"";
        height:1px;
        top:50%;
        width: 100%;
        border-top: 1px solid #66b1ff;
      }
    }
    .medias{
      height: calc(100% - 40px);
      ul {
        height 100%
        overflow-y auto
        li {
          width 19.3%
          height 97%
          position relative
          margin-left 15px
          float left
          cursor default
          .picture {
            width 100%
            height: 100%;
            position relative
            .box {
              width: 100%;
              height: 100%;
              border-radius: 4px;
              border: 0.1px solid #00a0e9;
              .pic {
                width: 100%;
                height: 100%;
                cursor: pointer;
                border-radius: 4px;
                -o-object-fit: fill;
                object-fit: fill;
              }
            }
            .pic_contrl {
              width: 100%;
              position: absolute;
              bottom: 5px;
              left: 1px;
              background rgba(0, 0, 0,0.6)
              .video-time-pic {
                width: 100%;
                height: 32px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                font-size 12px
                font-weight 400
                color #fff
                line-height: 16px;
                overflow: hidden
                text-overflow: ellipsis
                white-space: nowrap
                  span {
                    margin-left 9px
                    font-size 12px
                  }
              }
            }
            .center {
              position absolute
              top 50%
              left 50%
              transform translate(-50%,-50%)
              width 40px
              heigth 40px
              cursor: pointer
            }
          }

        }
        li:nth-child(5n+1) {
          margin-left 0
        }
      }
    }
    .one-line {
      height: 92%
      .medias ul li {
        height: 30%
        margin-bottom: 20px
      }
    }
  }
}
::-webkit-scrollbar
  width 6px
  height 6px
  background-color #EBEBEB
// 滚动条里面可以拖动的那部分
::-webkit-scrollbar-thumb
  border-radius 4px
  background-color #9f9d9d
  width 20px !important
// 深色样式
.theme-dark {
  .page-container {
    background-color: #001143;
    .content {
      .medias{
        ul {
          li {
            .video {
              #amplifyVideo {
                background #041d5d
              }
              .exVideoTitle {
                color #00E4FF
                background url('~@/icon/newBg/img_head1-m.png') no-repeat
              }
            }
          }
        }
      }
    }

    .li-container {
      background: rgba(#002A96, 0.8);


      .li-title {
        background-image: url('~@/icon/focus/ic_headimg.png');
        color: #00E4FF;
      }

      .el-icon-edit {
        color: #00deff;
      }

      .no-tips {
        color: rgba(255, 255, 255, 0.5);
      }

      .vedio-label {
        color: #fff;
      }

      .gps-box {
        ul {
          li {
            border-bottom: 1px solid #2A5CBA;
            .gps-li {
              .label-box {
                h5 {
                  color: #00DEFF;
                }

                p {
                  color: #ffffff;
                }
              }
            }
          }
        }
      }
    }
  }

  .important-img {
    .img-title {
      color: #fff;
      border: 1px solid #00DEFF;

      .name {
        color: #fff;
      }
    }
  }
}
/deep/.analy {  .el-input__inner {
    padding: 12px 20px 12px 30px !important;
  }
}
.search .el-form .el-form-item:last-child {
  margin-top: 0 !important;
}
</style>
